export default __webpack_public_path__ + "static/bg-tower-632cec8baab0d4c51725ec9eff46c941.jpg";